import type { Extractor } from "../types.js";

export const extractAny: Extractor = () => ({ type: "any" });
